import { render, staticRenderFns } from "./deviceMQ.vue?vue&type=template&id=23a33d38&scoped=true&"
import script from "./deviceMQ.vue?vue&type=script&lang=js&"
export * from "./deviceMQ.vue?vue&type=script&lang=js&"
import style0 from "./deviceMQ.vue?vue&type=style&index=0&id=23a33d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a33d38",
  null
  
)

export default component.exports